import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';

/**
 * Abstract command
 *
 * @class AbstractCommand
 */
export default class AbstractCommand {
    aborted = false;

    /**
     * Execute command
     */
    execute() {}

    /**
     * Unexecute command
     */
    unexecute() {}

    /**
     * Is this a valid command?
     *
     * @return {boolean}
     */
    isValid() {
        return true;
    }

    /**
     * Is this a command aborted?
     *
     * @return {boolean}
     */
    isAborted() {
        return this.aborted;
    }

    /**
     * Abort command
     */
    abort() {
        this.aborted = true;
    }

    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        return 'AbstractCommand';
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.AbstractCommand = AbstractCommand;
